module.exports = __webpack_public_path__ + "static/media/qAtmosphereInfo5.07f626a0.webp";